/* eslint-disable @typescript-eslint/no-empty-function */

import React from 'react';

export type RadioGroupContextProps = {
  name: string;
  selectedValue: string;
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
};

export const RadioGroupContext = React.createContext<
  Partial<RadioGroupContextProps>
>({
  name: '',
  selectedValue: '',
  onChange: () => {},
});
